import React from 'react';
import { ModuleBridge } from '../components';

export const ReportingBackups = () => {
    return <ModuleBridge moduleId="reporting_backups_module" />;
};
